'use client';
import { DialogContentStyled } from './dialog-content.styles';

const DialogContent = DialogContentStyled;

export default DialogContent;
